<template>
  <main>
    <div id="app" :class="{ 'dark': getDarkMode }" class="flex h-screen overflow-y-hidden bg-white">
      <HeaderComponent class="mb-16" />
      <SideNav
        class="fixed inset-y-0 max-lg:z-40 flex flex-col flex-shrink-0 w-full lg:w-64 max-h-screen overflow-x-hidden overflow-y-auto transition-all transform shadow-lg lg:border-r lg:static lg:shadow-none duration-1000"  
        :class="{'max-lg:hidden': !getshowSideNav}" />
      <div :class="getAlerts.length > 0 && 'space-y-1 sm:py-3'" class="fixed top-0 w-full" style="z-index: 999;">
        <AlertComponent v-for="(alert, index) in getAlerts" :key="index" :alert="alert"/>
      </div>

      <router-view class="w-full min-h-screen max-lg:pt-16 overflow-y-auto dark:bg-black dark:text-gray-200 dark:border-primary"/>
      
      <ModalImage v-if="getShowModalNewImage" />
    </div>
  </main>
</template>

<script>
  import { mapGetters } from 'vuex';
  import HeaderComponent from '@/components/HeaderComponent.vue';
  import AlertComponent from './components/helper/AlertComponent.vue'
  import SideNav from '@/components/SideNav';
  import ModalImage from '@/components/ModalImageComponent';

  export default {
    components: {
      HeaderComponent,
      AlertComponent,
      SideNav,
      ModalImage
    },
    computed: {
      ...mapGetters(['getAlerts', 'getDarkMode', 'getshowSideNav', 'getShowModalNewImage', 'getUser', 'getLoadingUser']),
    },
  }
</script>

<style lang="scss">

  html {
      font-family:
          Roboto,
          'Source Sans Pro',
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          'Helvetica Neue',
          Arial,
          sans-serif;
      font-size: 16px;
      word-spacing: 1px;
      -ms-text-size-adjust: 100%;
      -webkit-text-size-adjust: 100%;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
      box-sizing: border-box;
      background-color: white;
  }

  *,
  *::before,
  *::after {
      box-sizing: border-box;
      margin: 0;
  }

  .__alert {
      backdrop-filter: blur(10px);
      background-color: rgba(0, 195, 255, 0.041);
  }

  button {
    cursor: pointer;
  }

  li {
    list-style-type: none;
  }

  ul {
    padding: 0;
  }

  /* SCROLLBAR */
  ::-webkit-scrollbar { /* width */
  width: 6px;
  }
  ::-webkit-scrollbar-track { /* Track */
  background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb { /* Handle */
  background: #888;
  }
  ::-webkit-scrollbar-thumb:hover { /* Handle on hover */
  background: #555;
  }

  li {
    list-style-type: none;
  }

</style>